

































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import config from '@/config/index';
import { Bar, Line, Doughnut, Radar } from 'vue-chartjs';
import { AxiosVue } from '@/AxiosVue';
import { EstadoEntidad, ServicioProxy, TipoRol } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import { fetchDashboard } from '@/pantallas/Dashboard/fetchDashboard';
import ExportMenu from '@/pantallas/Dashboard/ExportMenu.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  exportCsv,
  exportExcel,
  exportJson,
} from '@/pantallas/Dashboard/ExportFile';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    doughnutComp: Doughnut,
    exportMenu: ExportMenu,
  },
})
export default class DashboardOs extends Vue {
  readonly loadingService = new LoadingService();
  @Prop() load: boolean;
  @Prop() loadOperation: boolean;
  //Fetch
  axiosVehiculo: AxiosVue = new AxiosVue(ServicioProxy.Vehiculo);
  readonly controllerFlota: string = 'flota';

  // State
  oldFleetsSelected: string[] = [];
  fleetsSelected: string[] = [];
  search: any = '';
  fleets: string[] = [];
  sideBar: any = config.agGridDefaultConfig;
  inLinePercent: string = '0';
  offLinePercent: string = '0';
  total: string = '0';
  stopLoading: boolean = false;
  $snotify: any;
  checkAllFleets: boolean = false

  // Pointss
  mousePointTransmission: Boolean = false;
  mousePointTransmissionDetail: Boolean = false;

  // Grid
  columnDefsTransmission: any = [
    { field: 'patente', sortable: true, headerName: 'Patente' },
    { field: 'fechaactividad', sortable: true, headerName: 'Fecha actividad' },
    { field: 'ubicacion', sortable: true },
    { field: 'flotas', sortable: true },
    { field: 'latitud', sortable: true },
    { field: 'longitud', sortable: true },
    { field: 'dias_sin_transmitir', sortable: true, headerName: 'Días sin Transmisión' },
  ];
  rowDataTransmission: [] = [];
  gridOptionTransmission: GridOptions;

  // Graphics
  transmissionGraphic: any = {};


  selectAllFleets(){
    if(this.checkAllFleets){
      this.fleetsSelected = this.fleets.map((item:any)=> item.id);
    }else{
      this.fleetsSelected = [];
    }
  }


  constructor() {
    super();

    this.gridOptionTransmission = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
  }
  @Watch('load')
  onLoadChanged(value: boolean, oldValue: boolean) {
    this.mountGraphicTransmission();
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 13) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  percents(type: string) {
    let list: any = this.transmissionGraphic;
    if (list.EN_LINEA != '' && list.FUERA_DE_LINEA != '') {
      let inLine: number = parseInt(list.EN_LINEA);
      let offLine: number = parseInt(list.FUERA_DE_LINEA);
      if (type == 'inLine') {
        let sum = (inLine * 100) / (inLine + offLine);
        return (Math.round((sum + Number.EPSILON) * 100) / 100).toFixed(0);
      } else {
        let sum = (offLine * 100) / (inLine + offLine);
        return (Math.round((sum + Number.EPSILON) * 100) / 100).toFixed(0);
      }
    } else {
      return 0;
    }
  }

  sumTotal() {
    let list: any = this.transmissionGraphic;
    if (list.EN_LINEA != '' && list.FUERA_DE_LINEA != '') {
      let inLine: number = parseInt(list.EN_LINEA);
      let offLine: number = parseInt(list.FUERA_DE_LINEA);
      let sum = inLine + offLine;
      return sum;
    } else {
      return 0;
    }
  }

  exportData(type: string, extension: string) {
    var exportData: {}[] = [];
    switch (type) {
      case 'transmission':
          return {
            'En linea': this.transmissionGraphic.EN_LINEA,
            'Fuera de linea': this.transmissionGraphic.FUERA_DE_LINEA,
          };
        break;
      case 'transmissionDetail':
        exportData = this.rowDataTransmission;
        break;
    }
    switch (extension) {
      case 'csv':
        exportCsv(exportData, type);
        break;
      case 'xlsx':
        exportExcel(exportData, type);
        break;
      case 'json':
        exportJson(exportData, type);
        break;
    }
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  filterFleets() {
    var self = this;
    setTimeout(() => {
      self.loadGraphicFetch();
    }, 500);
    // if (
    //   JSON.stringify(this.oldFleetsSelected) !==
    //   JSON.stringify(this.fleetsSelected)
    // ) {
    //   this.loadGraphicFetch();
    // }
  }

  updateTags() {
    this.$nextTick(() => {
      this.fleetsSelected.push(...this.search.split(','));
      this.$nextTick(() => {
        this.search = '';
      });
    });
  }

  async getFleets(): Promise<void> {
    try {
      var user = this.getUserID();
      var client = this.getClientID();
      const response = await this.axiosVehiculo.http.get(
        `${'flota'}/${user}/${client}/usuarioflotacliente/`
      );
      this.fleets = response.data;
    } catch (error) {
      console.log(error);
    }
  }

  created(): void {
    this.getFleets();
  }

  mounted(): void {
    this.loadGraphicFetch();
    (this.$refs.doughnutCompRef as Doughnut).addPlugin(ChartDataLabels);
  }

  extractName(fleets: any) {
    var returnNames: string[] = [];
    for (let item of fleets) {
      returnNames.push(item['nombre']);
    }
    return returnNames;
  }

  async loadGraphicFetch() {
    this.transmissionGraphic = [];
    this.rowDataTransmission = [];
    this.inLinePercent = "";
    this.offLinePercent = "";
    this.total = "";
    let model = {
      nameId: this.getUserID(),
      clienteId: this.getClientID(),
      date: '',
      patents: '',
      fleets: this.fleetsSelected,
    };
    this.loadingService.showLoading('Por favor espere...', 'dashboardTs');
    await fetchDashboard(model, 'graficos_track3_v2/get_estado_transmision')
    .then((response: any) => response.data)
    .then((response: any) => {
      if (response.CODIGO_RESPUESTA != '1') {
          this.$snotify.error(response.MENSAJE_RESPUESTA);
        }else{
          this.transmissionGraphic = response.t_graph;
          this.inLinePercent = this.percents('inLine').toString();
          this.offLinePercent = this.percents('offLine').toString();
          this.total = this.sumTotal().toString();
          this.rowDataTransmission = response.t_detail;
        }
    })
    .catch((error: any) => {
      console.log(error)
    })
    .finally(() => {
      this.loadingService.hideLoading('dashboardTs');
    })
  }

  @Watch('transmissionGraphic')
  onTransmissionChanged(value: string, oldValue: string) {
    this.mountGraphicTransmission();
  }


  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }

  formatGraphicTransmission(data: any) {
    var labels: any = ['en línea', 'fuera de línea'];
    var values: any = [];
      values.push(data['EN_LINEA']);
      values.push(data['FUERA_DE_LINEA']);

    return { labels: labels, values: values };
  }

  mountGraphicTransmission() {
    var data = this.formatGraphicTransmission(this.transmissionGraphic);
    (this.$refs.doughnutCompRef as Doughnut).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: 'Transmisión',
            data: data.values,
            backgroundColor: ['#8dd0b3', '#f44924'],
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let datasets: any = ctx.chart.data.datasets;
              let percentage = '0';
              if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                let sum: any = datasets[0].data.reduce(
                  (a: any, b: any) => parseFloat(a) + parseFloat(b),
                  0
                );
                percentage = Math.round((value / sum) * 100) + '%';
                return percentage;
              } else {
                return percentage;
              }
            },
            color: '#fff',
          },
        },
      }
    );
  }
}
